import React, { Ref } from 'react';
import clsx from 'clsx';
import TextareaAutosize, {
  TextareaAutosizeProps,
} from 'react-textarea-autosize';

import styles from './Input.module.scss';

type Props = TextareaAutosizeProps & {
  containerClassName?: string;
  hasFixedSize?: boolean;
  helperText?: string;
  errorText?: string;
  leftHelperText?: string;
  rightHelperText?: string;
  bottomHelperText?: string;
  topHelperText?: string;
  topRightHelperText?: string;
  fullWidth?: boolean;
  testId?: string;
};

export const TextArea = React.forwardRef(function TextArea(
  props: Props,
  ref: Ref<HTMLTextAreaElement>,
) {
  const {
    hasFixedSize,
    helperText,
    leftHelperText,
    topHelperText,
    topRightHelperText,
    bottomHelperText,
    rightHelperText,
    errorText,
    className,
    readOnly,
    style,
    fullWidth,
    containerClassName,
    disabled,
    testId,
    ...rest
  } = props;

  return (
    <div
      data-test-id={testId}
      style={style}
      className={clsx(
        styles.inputContainer,
        fullWidth && styles.fullWidth,
        containerClassName,
      )}
    >
      <div className={clsx(styles.rowContainer, disabled && styles.opacity_50)}>
        {leftHelperText && (
          <div className={styles.inputHelperText}>{leftHelperText}</div>
        )}
        <div
          className={clsx(
            styles.columnContainer,
            fullWidth && styles.fullWidth,
          )}
        >
          <div
            style={{
              justifyContent:
                !topHelperText && topRightHelperText
                  ? 'flex-end'
                  : 'space-between',
            }}
            className={styles.rowContainer}
          >
            {topHelperText && (
              <div className={styles.inputHelperText}>{topHelperText}</div>
            )}
            {topRightHelperText && (
              <div className={styles.inputHelperTextGrey}>
                {topRightHelperText}
              </div>
            )}
          </div>
          <TextareaAutosize
            data-error={!!props.errorText}
            ref={ref}
            rows={3}
            className={clsx(
              styles.input,
              readOnly && styles.readOnly,
              disabled && styles.disabled,
              className,
            )}
            maxRows={hasFixedSize ? 1 : undefined}
            {...rest}
          />
          {errorText && (
            <div className={styles.inputErrorText}>{errorText}</div>
          )}
          {bottomHelperText && !errorText && (
            <div className={styles.inputHelperText}>{bottomHelperText}</div>
          )}
        </div>

        {rightHelperText && (
          <div className={styles.inputHelperText}>{rightHelperText}</div>
        )}
      </div>
    </div>
  );
});
